import { percent } from 'utils/math'
import { putShortId } from 'utils/minIds'
import { intcmp } from 'utils/string'

export const defaultProgress = Object.freeze({
  total: 0,
  percent: 0,
  finished: 0,
  feedback: 0,
  returned: 0,
  submitted: 0,
  working: 0
})

export const ANSWER_STATUS = {
  WORKING: 0,
  SUBMITTED: 1,
  ACCEPTED: 2,
  RETURNED: 3
}

function normalizeChallengeInputGroup(
  { id, name, order, links, visibleId, iLinksD },
  actor
) {
  let iLinksSort = {}
  if (!links && iLinksD) links = Object.values(iLinksD)

  // temp filter only show Spark only when we have an actor (no actor is admin)
  // if (actor) {
  // if (viewChallengeInputGroupId) {
  //   links = links.filter(
  //     (c) => c.visibleId === viewChallengeInputGroupId
  //   )
  // }
  // }

  iLinksD = links.reduce((map, link) => {
    // defaultChallengeInputLink?
    link = { ...link }
    map[link.id] = link

    if (actor) {
      let answerId = actor.answersInputD[link.input.id]
      if (answerId) {
        link.answerId = answerId
      } else {
        link.answerId = undefined
      }
    }
    putShortId(map, iLinksSort, link)

    return map
  }, {})

  const iLinksL = links
    .toSorted((b, a) => intcmp(b.order, a.order))
    .map((a) => a.id)

  const linkShow = iLinksL
  // const linkShow = iLinksL.filter((id) => {
  //   const qmap = iLinksD[id]
  //   const thisId = qmap.visibleId || visibleId
  //   if (thisId && milestonesOpen[thisId]) {
  //     return true
  //   }
  //   return false
  // })

  // calculate progress within this group
  let progress = { ...defaultProgress }
  if (actor) {
    progress = iLinksL.reduce((progress, qMapId) => {
      progress.total++
      const qmap = iLinksD[qMapId]
      const answer = actor.answersD[qmap.answerId]
      switch (answer?.statusA) {
        case ANSWER_STATUS.ACCEPTED:
          progress.finished++
          break
        case ANSWER_STATUS.RETURNED:
          progress.returned++
          break
        case ANSWER_STATUS.SUBMITTED:
          progress.submitted++
          break
        case ANSWER_STATUS.WORKING:
          progress.working++
          break
        default:
      }

      if (answer?.feedback) {
        progress.feedback++
      }
      return progress
    }, progress)

    progress.percent = percent(progress.finished / progress.total)
  }

  return Object.freeze({
    id,
    name,
    order,
    visibleId,
    iLinksL,
    iLinksD,
    linkShow,
    progress
  })
}

//////////////////////////////////////////////////////////////////////////////
export function normalizeChallengeInputGroups(groups, actor) {
  let groupsL = []
  let groupsD = {}
  let groupsShort = {}
  let groupsShow = []

  if (groups !== undefined) {
    groupsL = groups.toSorted((a, b) => intcmp(a.order, b.order)).map((r) => r.id)
    ;[groupsD, groupsShort] = groups.reduce(
      ([groupsD, groupsShort], group) => {
        putShortId(
          groupsD,
          groupsShort,
          normalizeChallengeInputGroup(group, actor)
        )
        return [groupsD, groupsShort]
      },
      [{}, {}]
    )
    groupsShow = groupsL

    // groupsShow = groupsL.filter((id) => {
    //   const group = groupsD[id]
    //   if (group.visibleId && milestonesOpen[group.visibleId]) {
    //     return true
    //   }
    //   return false
    // })
  }
  return { groupsL, groupsD, groupsShow, groupsShort }
}
